import { Theme } from '@mui/material/styles';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

const Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" fill="none" stroke="currentColor" strokeWidth="2.2" />
  </SvgIcon>
);

const CheckedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" fill="currentColor" />
    <path
      d="M8.3 12.4 10.8 15l5.2-5.5"
      fill="none"
      stroke="#F8FAFC"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const IndeterminateIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" fill="currentColor" />
    <path
      d="M8 12h8"
      fill="none"
      stroke="#F8FAFC"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default function Checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        size: 'small',
        icon: <Icon />,
        checkedIcon: <CheckedIcon />,
        indeterminateIcon: <IndeterminateIcon />,
      },

      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          color: theme.palette.grey[500],
          transition: theme.transitions.create(['color', 'transform'], {
            duration: theme.transitions.duration.shorter,
          }),
          '&:hover': {
            backgroundColor: 'transparent',
            transform: 'translateY(-1px)',
          },
          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: theme.palette.primary.main,
          },
          '&.Mui-disabled': {
            color: theme.palette.action.disabled,
          },
        },
      },
    },
  };
}
